import { render } from "./Crypto.vue?vue&type=template&id=a5a4dd58"
import script from "./Crypto.vue?vue&type=script&lang=js"
export * from "./Crypto.vue?vue&type=script&lang=js"

import "./Crypto.vue?vue&type=style&index=0&id=a5a4dd58&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__